module.exports = __webpack_public_path__ + "static/media/machines-and-gadgets-header.f00a498a.JPG";